import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemButton, ListItemText, Typography, ListItemIcon } from '@mui/material';
import axios from 'utils/axios';
import { getNotifcations, getEventDetail } from 'utils/apolloQueries';
import HistoryListSkeleton from 'ui-component/cards/Skeleton/HistoryList';
import TodayIcon from '@mui/icons-material/Today';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import SkeletonNotification from 'ui-component/cards/Skeleton/Notifications';
import { useNavigate } from 'react-router';
import { setNewDate } from 'store/Calendar/actions';
import { updateCalendarDate } from 'utils/functions';
import { useMutation } from '@apollo/client';
import { READ_NOTIFICATION_BY_ID } from 'schemas/mutation';
import { setSelectedIdtoView } from 'store/Questions/actions';
const NotificationList = (props) => {
    const { companyData } = useSelector((params) => params.customization);
    const [notification, setNotification] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [teamMember, setTeamMembers] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [readNotification] = useMutation(READ_NOTIFICATION_BY_ID);
    useEffect(() => {
        let submitData = {
            query: getNotifcations,
            variables: {
                notificationListInput: {
                    companyId: companyData._id,
                    page: 1,
                    limit: 5
                },
                teamMembersListInput: {
                    companyId: companyData._id,
                    limit: 999,
                    page: 1
                }
            }
        };
        axios({
            method: 'POST',
            data: submitData
        })
            .then(function (response) {
                if (response.status === 200) {
                    const { getNotifications, getTeamMembers } = response.data.data;
                    if (getNotifications.items && getNotifications.items.length > 0) {
                        setNotification(getNotifications.items);
                        props.setUnreadNotification(0);
                        props.setIsAllRead(getNotifications.isAllread);
                        if (getTeamMembers.items && getTeamMembers.items.length > 0) {
                            setTeamMembers(getTeamMembers.items);
                        }
                    }
                    setIsLoading(false);
                }
            })
            .catch(function () {});
    }, [props.message]);
    const notificationUrl = async (item) => {
        if (!item.hasRead) {
            await readNotification({
                variables: {
                    notificaion: {
                        notificationId: item._id
                    }
                }
            });
        }
        if (item?.notificationType === 'event-created') {
            let submitData = {
                query: getEventDetail,
                variables: {
                    eventInput: {
                        companyId: companyData._id,
                        eventId: item.metaData.eventId
                    }
                }
            };
            axios({
                method: 'POST',
                data: submitData
            })
                .then(function (response) {
                    if (response.status === 200) {
                        const { getCompanyEvent } = response.data.data;
                        dispatch({ type: setNewDate, newDate: updateCalendarDate(getCompanyEvent.date) });
                    }
                })
                .catch(function () {});
            navigate('calendar');
        } else if (item?.notificationType === 'announcement-milestone-reached') {
            if (item?.metaData?.announcementId) {
                navigate('announcements/' + item.metaData.announcementId);
            } else {
                navigate('announcements');
            }
        } else if (
            item.notificationType === 'enquiry-assigned' ||
            item.notificationType === 'enquiry-received' ||
            item.notificationType === 'enquiry-responded' ||
            item.notificationType === 'enquiry-re-opened' ||
            item.notificationType === 'enquiry-closed'
        ) {
            if (item?.metaData?.enquiryId) {
                dispatch({
                    type: setSelectedIdtoView,
                    selectedIdToView: item.metaData.enquiryId
                });
            }
            navigate('questions');
        }
    };
    const getData = (item) => {
        let notificationType = item.notificationType;
        let avatar = '';
        let title = item.title;
        let jobTitle = '';
        let message = item.message;
        if (notificationType.includes('milestone')) {
            avatar = <DataUsageIcon sx={{ width: '48px', height: '48px', mr: '20px' }} className="icon-yellow-fill" />;
        } else {
            if (notificationType.includes('enquiry')) {
                avatar = <ForumOutlinedIcon sx={{ width: '48px', height: '48px', mr: '20px' }} className="icon-yellow-fill" />;
            } else {
                avatar = <TodayIcon sx={{ width: '48px', height: '48px', mr: '20px' }} className="icon-yellow-fill" />;
            }
        }
        if (item?.notificationType) {
            if (item.notificationType === 'announcement-milestone-reached') {
                if (item.title === '100%-view') {
                    title = '100% View!';
                } else if (item.title === '50%-view') {
                    title = '50% View!';
                } else if (item.title === '80%-view') {
                    title = '80% View!';
                }
            } else if (
                item.notificationType === 'enquiry-assigned' ||
                item.notificationType === 'event-created' ||
                item.notificationType === 'event-deleted'
            ) {
                if (item?.userObject?._id) {
                    title = item.userObject.userName;
                    jobTitle = item.userObject.jobTitle;
                }
                if (item.title === 'Event created') {
                    message = 'Just created an event';
                } else if (item.title === 'Event updated') {
                    message = 'Just updated an event';
                } else if (item.title === 'Event deleted') {
                    message = 'Just deleted an event';
                } else if (item.title === 'Question assigned') {
                    message = 'You have been assigned a question.';
                }
            }
        }
        return (
            <ListItemButton
                component="a"
                onClick={() => {
                    notificationUrl(item);
                    props.handleClose();
                }}
                sx={{ padding: 0, background: 'transparent !important' }}
            >
                <ListItemIcon>{avatar}</ListItemIcon>
                <ListItemText
                    primary={
                        <Typography component="h4" variant="h4">
                            {title}
                        </Typography>
                    }
                    secondary={
                        <Typography component="span" variant="body2">
                            {message}
                        </Typography>
                    }
                />
                <div>
                    {jobTitle && (
                        <Typography variant="h6" component="h6">
                            {jobTitle}
                        </Typography>
                    )}
                </div>
            </ListItemButton>
        );
    };
    return (
        <List>
            {isLoading ? (
                <SkeletonNotification />
            ) : (
                <>
                    {notification ? (
                        <>
                            {notification.length > 0 ? (
                                notification.map((item, index) => (
                                    <ListItem sx={{ display: 'block' }} key={index} className={item.hasRead ? 'read' : 'unread'}>
                                        {getData(item)}
                                    </ListItem>
                                ))
                            ) : (
                                <HistoryListSkeleton />
                            )}
                        </>
                    ) : (
                        <ListItem sx={{ display: 'block' }}>No notifications available</ListItem>
                    )}
                </>
            )}
        </List>
    );
};

export default NotificationList;
